import React from "react";

const VARIANTS = [
  { bg: "#0C0C0C", fg: "#F4F4F0", accent: "#D4F731" },
  { bg: "#2E6BFF", fg: "#F4F4F0", accent: "#0C0C0C" },
  { bg: "#D4F731", fg: "#0C0C0C", accent: "#2E6BFF" },
  { bg: "#171717", fg: "#F4F4F0", accent: "#2E6BFF" },
];
const hash = (s = "") => { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return h; };

/* Auto-generated editorial poster for events without artwork. Deterministic variant per event. */
export default function PosterFrame({ event, className = "" }) {
  const v = VARIANTS[hash(event?.id || event?.title || "") % VARIANTS.length];
  const d = event?.date ? new Date(event.date) : null;
  const day = d ? String(d.getDate()).padStart(2, "0") : "--";
  const mon = d ? d.toLocaleDateString("en-IN", { month: "short" }).toUpperCase() : "";
  const yr = d ? d.getFullYear() : "";
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} style={{ background: v.bg, color: v.fg }} data-testid={`poster-frame-${event?.id || "x"}`}>
      <div className="absolute inset-2 p-3.5 flex flex-col justify-between" style={{ border: `1px solid ${v.fg}26` }}>
        <div className="flex items-start justify-between gap-2">
          <div className="font-mono text-[9px] font-bold uppercase tracking-[0.2em]" style={{ color: v.accent === v.bg ? v.fg : v.accent }}>{event?.category || "Event"}</div>
          <div className="text-right leading-none">
            <div className="font-display text-2xl">{day}</div>
            <div className="font-mono text-[8px] font-bold tracking-[0.18em]">{mon} {yr}</div>
          </div>
        </div>
        <div>
          <div className="font-display uppercase leading-[0.92] break-words line-clamp-4" style={{ fontSize: "clamp(20px, 2.2vw, 30px)" }}>{event?.title}</div>
          <div className="mt-2 pt-2 flex items-center justify-between font-mono text-[8px] font-bold uppercase tracking-[0.2em]" style={{ borderTop: `1px solid ${v.fg}40` }}>
            <span>{event?.city || "India"}</span>
            <span style={{ color: v.accent === v.bg ? v.fg : v.accent }}>EVENTOM</span>
          </div>
        </div>
      </div>
    </div>
  );
}
